import { useMemo } from 'react';
import { Crop, BgRot, GoldButton, fitScene } from './Shared';

/* ------------------------------------------------------------------
   "Gold Chest earned" — full-screen celebration over the hub for a chest
   the user hasn't been shown yet (wallet.chests[].celebrated false).
   `onDone` marks it seen and returns to the hub. Laid out on the 375px
   stage; the parent sizes / zooms it to the viewport.
   ------------------------------------------------------------------ */

/* chest top:170 → stat bottom 612 on the 812px design; may rise to 60 and
   must clear the bottom-anchored CTA (46 + 36 + a 16px gap) */
const SCENE = { designTop: 170, height: 442, minTop: 60, bottom: 98 };

export default function Celebrate({ chest, chestCount, drawDay = '13 November', zoom = 1, stageHeight = 812, onDone }) {
  const fit = useMemo(() => fitScene(stageHeight, SCENE), [stageHeight]);
  const isRef = chest.streak === 'ref';
  const copy = isRef
    ? `Your ${chest.streakName} streak is complete. This chest is in the grand draw on ${drawDay}, and every friend who joins from here is still +1 Gem.`
    : `Your ${chest.streakName} streak is complete. This chest opens in the grand draw on ${drawDay}.`;

  return (
    <div className="gq-overlay">
      <div className="gq-celebrate" style={{ zoom, height: stageHeight }} role="dialog" aria-modal="true" aria-label="Gold Chest earned">
        <BgRot />
        <div className="gq-scene" style={fit.style}>
          <Crop kind="chest" className="gq-cglow" />
          <Crop kind="chest" className="gq-bigchest" />
          <div className="gq-copy">
            <div className="gq-h">Gold Chest earned</div>
            <div className="gq-p">{copy}</div>
          </div>
          <div className="gq-stat"><span>Chests in the draw</span><b>{chestCount}</b></div>
        </div>
        <GoldButton onClick={onDone}>Keep going</GoldButton>
      </div>
    </div>
  );
}
